// NavigationSetter.jsx (또는 App.js 안에 작성)
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setNavigate } from "../utils/navigation";

const NavigationSetter = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null; // 화면에 아무것도 안 그림
};

export default NavigationSetter;
